/*globals Settings*/

//Used for postMessaging custom data to the parent window when MGP is framed in.
//BODY HEIGHT CANNOT BE SET TO 100% OR 100vh OR CONTENT HEIGHT DOESN'T WORK CORRECTLY (will infinite loop with increasing contentHeight)!!!!!
var MgpCustomData = {};

var MessageCustomData = (function () {
  'use strict';

  var DEBOUNCE_TIME = 50;

  var init = function () {
    //Check if mgp is framed in
    if (window.parent.location !== window.location) {
      window.addEventListener('load', function () {
        var documentElementStyle = document.documentElement.style,
          bodyStyle = document.body.style,
          aureliaBlockAppMainElement = document.querySelector('[aurelia-app]'), //Only Exists for Aurelia Blocks
          angularBlockAppWrapperElement = document.querySelector('.blx-angular-app');  //Only Exists for Angular Blocks
           
        //BODY HEIGHT CANNOT BE SET TO 100% OR 100vh OR CONTENT HEIGHT DOESN'T WORK CORRECTLY (will infinite loop with increasing contentHeight)!!!!!
        documentElementStyle.height = 'auto';
        documentElementStyle.minHeight = 'auto';
        documentElementStyle.maxHeight = 'none';
        bodyStyle.height = 'auto';
        bodyStyle.minHeight = 'auto';
        bodyStyle.maxHeight = 'none';
        //Some institutional stylesheets (e.g. T. Rowe Price retirement-forecast Block at min-width: 960px)
        //set 'overflow: hidden' on body, which clips content out of body.offsetHeight and breaks
        //the iframed contentHeight calculation. Reset here so all the height we just opened up is
        //actually measured.
        bodyStyle.overflow = 'visible';

        //Only Exists for Angular Blocks
        if (angularBlockAppWrapperElement) {
          const angularBlockObserver = new MutationObserver(mutations => {
            
            if (document.querySelector('.c-blx-infrastructure-navigation-wizard-app-wrapper .c-app-wrapper')) {
              var angularAppWrapperElement = document.querySelector('.c-blx-infrastructure-navigation-wizard-app-wrapper .c-app-wrapper');

              angularAppWrapperElement.style.height = 'auto';
              angularAppWrapperElement.style.minHeight = 'auto';
              angularAppWrapperElement.style.maxHeight = 'none';
              angularAppWrapperElement.style.overflow = 'visible';
            }
            
            if (document.querySelector('.c-blx-infrastructure-navigation-wizard-app-wrapper .c-app-flex-container')) {
              var angularAppFlexContainerElement = document.querySelector('.c-blx-infrastructure-navigation-wizard-app-wrapper .c-app-flex-container');

              angularAppFlexContainerElement.style.height = 'auto';
              angularAppFlexContainerElement.style.minHeight = 'auto';
              angularAppFlexContainerElement.style.maxHeight = 'none';
              angularAppFlexContainerElement.style.overflow = 'visible';

              //disconnect after element furthest down the DOM tree has set height styles
              angularBlockObserver.disconnect();
            }
          });

          angularBlockObserver.observe(document.body, {
            childList: true,
            subtree: true
          });
        }

        //Only Exists for Aurelia Blocks
        if (aureliaBlockAppMainElement) {
          aureliaBlockAppMainElement.style.height = 'auto';
          aureliaBlockAppMainElement.style.minHeight = 'auto';
          aureliaBlockAppMainElement.style.maxHeight = 'none';
        }

        //All modern browsers and IE11 support MutationObserver but check anyways
        if (window.MutationObserver || window.WebKitMutationObserver) {
          createMutationObserver();
          getHeightSendData();
        }

        //Use debounce to prevent a crazy amount of postMessages to parent
        window.addEventListener('resize', debounce(function () {
          getHeightSendData();
        }, DEBOUNCE_TIME));

        sendContentHeightListener();
      });
    }
  };
  
  // From underscore.js 1.8.3 - Didn't want to have to globally include underscore.js
  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  var debounce = function (func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function () {
      var last = Date.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function () {
      context = this;
      args = arguments;
      timestamp = Date.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  var createMutationObserver = function () {
    var target = document.body,
      config = {
        attributes: true,
        attributeOldValue: false,
        characterData: true,
        characterDataOldValue: false,
        childList: true,
        subtree: true
      };

    //Use debounce to prevent a crazy amount of postMessages to parent
    var observer = new MutationObserver(debounce(function () {
      getHeightSendData();
    }, DEBOUNCE_TIME));

    observer.observe(target, config);
  };

  var getHeightSendData = function () {
    MgpCustomData.ContentHeight = getContentHeight();
    MessageCustomData.SendCustomData();
  };

  //get MGP content height so iframe can be resized and won't display scrollbars
  var getContentHeight = function () {
    var DEFAULT_BOTTOM_PRINT_FRAME_HEIGHT = 600,
        DEFAULT_BODY_HEIGHT = 600,
        isPrintFrame = false,
        printBottomFrameHeight = 0,
        bodyElem = document.body,
        bodyElemScrollHeight = Math.ceil(bodyElem.scrollHeight),
        bodyElemOffsetHeight = Math.ceil(bodyElem.offsetHeight),
        bodyElemMarginTop = bodyElem.style.marginTop === '' ? 0 : Math.ceil(bodyElem.style.marginTop.replace('px', '')),
        bodyElemMarginBottom = bodyElem.style.marginBottom === '' ? 0 : Math.ceil(bodyElem.style.marginBottom.replace('px', '')),
        bodyElemVerticalMarginHeight = parseFloat(bodyElemMarginTop) + parseFloat(bodyElemMarginBottom), //In a Zoomer Plan marginBottom on body element is used for the footer
        bodyHeight = DEFAULT_BODY_HEIGHT;

    //Need a try/catch for parent frame element because of instances where MGP is framed in by a cross-domain iframe
    try {
      if (window.parent.document.getElementById('mgp-app-report-top-frame')) {
        isPrintFrame = true;
      }
    }
    catch (e) {
      //Cannot get the parent frame element because of CORS
    }
    finally {
      //https://stackoverflow.com/questions/14334154/iframe-auto-adjust-height-as-content-changes/14334416#answer-22991952
      //https://github.com/davidjbradshaw/iframe-resizer
      //David Bradshaw - iframe-resizer author recommends document.body.offsetHeight + document.body.style.marginTop + document.body.style.marginBottom;
      if (bodyElemOffsetHeight > 0) {
        bodyHeight = bodyElemOffsetHeight;
      } else if (bodyElemScrollHeight > 0) { //fallback shouldn't really ever use this
        bodyHeight = bodyElemScrollHeight; //document.body.scrollHeight has ever increasing contentHeight issue in Edge for Blocks - JIRA BLOCKS-349
      }

      if (isPrintFrame) {
        printBottomFrameHeight = DEFAULT_BOTTOM_PRINT_FRAME_HEIGHT; //set height for the bottom pdf print frame if it exists
      }

      return Math.ceil(parseFloat(bodyHeight)) + Math.ceil(parseFloat(bodyElemVerticalMarginHeight)) + Math.ceil(parseFloat(printBottomFrameHeight)) + parseInt(2);  //Add 2 pixels in case of borders or some other edge case
    }
  };
  
  //Listen for a requestContentHeight postMessage from the parent window to send the content height to the parent window whenever the 
  //parent window requests it (as of 12/04/2018 only used by Prudential)
  var sendContentHeightListener = function () {
    window.addEventListener('message', function (e) {
      var origin = e.origin;

      if (origin === Settings.ParentOriginDomain || origin === Settings.ParentOriginDomain2) {
        try {
          var data = JSON.parse(e.data);

          if (data.requestContentHeight === true) { //This JSON property (requestContentHeight) should be the same for all institutions
            getHeightSendData();
          }
        } catch (e) {
          console.log(e);
          return false;
        }
      }
    });
  };

  return {
    IsSinglePageConversationLegacyIframe: function () {
      //Bail out if we are the top-level (parent) window. Otherwise window.parent === window and the
      //getElementById below could find the parent's OWN legacy step iframe element and incorrectly
      //report the parent as the iframe.
      if (window.parent === window.self) {
        return false;
      }

      //Do this check in a try catch because if the window parent is cross-domain this will throw an error
      try {
        if (window.parent.document.getElementById('mg-conversation-legacy-step-iframe')) {
          return true;
        }
      } catch (e) {
        return false;
      }
    },

    SendCustomData: function () {
      var MgpCustomDataObj = {
        contentHeight: MgpCustomData.ContentHeight,  //MGP content height to resize top window iframe - integer format
        logoutURL: MgpCustomData.LogoutURL,          //MGP sign off url
        event: MgpCustomData.Event,                  //MGP event that triggered post message - values: MGP_GUEST_PLAN_FINISHED, etc.
        entitlements: MgpCustomData.Entitlements,    //MGP entitlements - semicolon delimited string
        action: 'resize'                             //Only used by US Bank for use with contentHeight to resize their iframed Blocks
      };

      if (MessageCustomData.IsSinglePageConversationLegacyIframe() && !Settings.PostMessageCustomData) {
        //set content height in case this is a single page conversation legacy step - can only do this since we are on the same domain
        window.parent.document.getElementById('mg-conversation-legacy-step-iframe').height = MgpCustomData.ContentHeight;
      }
      else if (Settings.PostMessageCustomData) {
        window.top.postMessage(JSON.stringify(MgpCustomDataObj), '*');  //postMessage window.top instead of window.parent in case using framed in version of MGP (myMG)
      }
    },
    Init: init
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  if (Settings.PostMessageCustomData || MessageCustomData.IsSinglePageConversationLegacyIframe()) {
    MessageCustomData.Init();
  }
});